import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { ClassCodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component";
import { FileDownloadConfirmService } from "src/app/commons/kymw02/file-download-confirm/file-download-confirm.service";
import { FileUploadService } from "src/app/commons/kymw02/file-upload/file-upload.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { GetClassBuyerIdService } from "../../kymw6900/api-services/get-class-buyer-id";
import { BuyerListModel } from "../../kymw6900/vo/buyer-model";
import { KYMW6902Component } from "../../kymw6902/kymw6902.component";
import { GetExistingGoodsCopyService } from "./api-services/get-existing-goods-copy.service";
import { GetNewGoodsProposalItemService } from "./api-services/get-new-goods-proposal-item.service";
import { ImagePhotoDownloadService } from "./api-services/image-photo-download.service";
import { ImagePhotoFileUploadService } from "./api-services/image-photo-file-upload.service";
import { RegistNewGoodsProposalService } from "./api-services/regist-new-goods-proposal.service";
import { RegistNewGoodsProposalGoodsService } from "./api-services/regist-new-goods-proposal-goods.service";
import { UpdateNewGoodsProposalService } from "./api-services/update-new-goods-proposal.service";
import { UpdateSuggestionStatusRecruimentService } from "./api-services/update-suggestion-status-recruiment.service";
import { UpdateSuggestionStatusRejectedService } from "./api-services/update-suggestion-status-rejected.service";
import { KYMW6901ProposalTabModel } from "./kymw6901-proposal-tab.model";
import { KYMW6900Model } from "../../kymw6900/kymw6900.model";
import { KYMW6901Model, KYMW6901Tab } from "../kymw6901.model";
import { CodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component";

@Component({
  selector: 'app-kymw6901-proposal-tab',
  templateUrl: 'kymw6901-proposal-tab.component.html',
  styleUrls: ['kymw6901-proposal-tab.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: GetNewGoodsProposalItemService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub,) => {
        return new GetNewGoodsProposalItemService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub, GetClassBuyerIdService]
    },
  ]
})
export class KYMW6901ProposalTabComponent extends PlessViewHelperSub implements OnInit, AfterViewInit {
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_TemperatureDiv', { static: true }) cmb_TemperatureDiv: CodeComboBoxComponent;
  @ViewChild('cmb_ManufacturingFactory', { static: true }) cmb_ManufacturingFactory: CodeComboBoxComponent;

  @Input() mode: KYMW6901Tab;
  @Input() passedProposalId: string;
  @Input() proposalId: string;
  @Input() proposalStatus: string;
  @Input() masterInputId: string;
  @Input() pCode: string;
  @Input() itemCode: string;
  @Input() classCode: string;
  @Input() searchParams: any;

  public model = new KYMW6901ProposalTabModel();
  private forbiddenCharactersRegex = /[\x00-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]/;
  private DUMMY_CLIENT_CODE = '99999999';
  private PREFERRED_EXPANSION_DIV_OTHER = '4';

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    protected kymw00Model: KYMW00Model,
    private fileUploadService: FileUploadService,
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getNewGoodsProposalItemService: GetNewGoodsProposalItemService,
    private getClassBuyerIdService: GetClassBuyerIdService,
    private imagePhotoFileUploadService: ImagePhotoFileUploadService,
    private imagePhotoDownloadService: ImagePhotoDownloadService,
    private updateNewGoodsProposalService: UpdateNewGoodsProposalService,
    private registNewGoodsProposalService: RegistNewGoodsProposalService,
    private registNewGoodsProposalGoodsService: RegistNewGoodsProposalGoodsService,
    private updateSuggestionStatusRecruimentService: UpdateSuggestionStatusRecruimentService,
    private updateSuggestionStatusRejectedService: UpdateSuggestionStatusRejectedService,
    private getExistingGoodsCopyService: GetExistingGoodsCopyService
  ) {
    super(kymw00Model);
    const coopMap = {
      [kymw00Model.COOP_CODE_IB]: 'ibaraki',
      [kymw00Model.COOP_CODE_TO]: 'tochigi',
      [kymw00Model.COOP_CODE_GU]: 'gunma',
      [kymw00Model.COOP_CODE_TI]: 'chiba',
      [kymw00Model.COOP_CODE_SA]: 'saitama',
      [kymw00Model.COOP_CODE_TK]: 'tokyo',
      [kymw00Model.COOP_CODE_NA]: 'nagano',
      [kymw00Model.COOP_CODE_NI]: 'niigata'
    };
    this.model.setCoopMap(coopMap);
  }

  ngOnInit() {
    this.componentName = 'KYMW6901ProposalTab';
    this.model.newGoodsProposal.classCode = this.classCode;

    this.model.loginUser = {
      userId: this.kymw00Model.kymw1001Model.loginUserInfo.UserID,
      associatedUserType: this.kymw00Model.kymw1001Model.loginUserInfo.AssociatedUserType,
      userClassList: this.kymw00Model.kymw1001Model.loginUserInfo.UserClassList.map(_ => {
        return {
          classCode: _.ClassCode,
          userClass: _.UserClass
        }
      })
    };

    if (this.passedProposalId) {
      this.getNewGoodsProposalItemService.execute(this.passedProposalId, this.model, (newGoodsProposal) => {
        this.model.newGoodsProposal = newGoodsProposal;
        this.getBuyerList();
        if (this.mode === KYMW6901Model.DISPLAY_MODE_REGIST) {
          this.model.clearOriginProposalInfo();
        }

        this.initElementsDisabled();
        this.initCodeCmbBox();
      });
    }
  }

  private getBuyerList() {
    this.getClassBuyerIdService.execute(this.model.newGoodsProposal.classCode, (buyerList) => {
      this.model.setBuyerList(buyerList);
    });
  }

  private initElementsDisabled() {
    // 提案前もしくは提案ステータスがない場合、全項目活性
    if (this.model.isBeforeProposing()) {
      return;
    }
    // 提案中かつバイヤーの場合、不採用理由以外の項目は非活性
    if (this.model.isBuyerEditable()) {
      this.model.setDisabled(true, ['rejectedReason']);
      setTimeout(() => {
        document.getElementById('txta_RejectedReason').addEventListener('change', () => {
          this.model.hasChanged = true;
        });
      });
      return;
    }
    // 上記以外の場合、全項目非活性
    this.model.setDisabled(true);
  }

  private initCodeCmbBox() {
    this.cmb_TemperatureDiv.setCodeValue(this.model.newGoodsProposal.temperatureDiv);
    this.cmb_ManufacturingFactory.setCodeValue(this.model.newGoodsProposal.manufacturingFactory);
  }

  ngAfterViewInit() {
    this.setChangeEvent();
  }

  private setChangeEvent() {
    const fieldIds = [
      'cmb_ClassCode',
      'cmb_BuyerUserId',
      'txti_GoodsName',
      'txti_StandardName',
      'txti_JanCode',
      'txti_SalesPoint',
      'txti_StandardSellingPrice',
      'txti_Special1SellingPrice',
      'txti_Special2SellingPrice',
      'txti_StandardCostPrice',
      'txti_Special1CostPrice',
      'txti_Special2CostPrice',
      'txti_ExpirationDate',
      'txti_BestBeforeDate',
      'cmb_PreferredStartOrderCode',
      'cmb_PreferredStartDelivCatalogId',
      'rdb_PrefferedExpansionDiv1',
      'rdb_PrefferedExpansionDiv2',
      'rdb_PrefferedExpansionDiv3',
      'rdb_PrefferedExpansionDiv4',
      'tbx_Other',
      'chk_AllCoop',
      'chk_Ibaraki',
      'chk_Tochigi',
      'chk_Gunma',
      'chk_Chiba',
      'chk_Saitama',
      'chk_Tokyo',
      'chk_Nagano',
      'chk_Niigata',
      'txb_MonthAge',
      'tbx_ProductionFactory',
      'cmb_ManufacturingFactory',
      'chk_DeliGoodsChecked',
      'chk_GoodsCheckRequest',
      'cmb_TemperatureDiv',
      'txti_orderClientName',
      'txti_MarkerName',
      'txb_Allergen',
      'txb_Additives',
      'txtb_CookingMethod',
      'chk_MobRegistered',
      'txb_ShootingInstruction',
      'txti_ImageFileName',
      'txb_ShootingImage',
      'txb_Note',
      'txti_PredictedPoints',
    ];
    fieldIds.forEach(fieldId => {
      document.getElementById(fieldId).addEventListener('change', () => {
        this.model.hasChanged = true;
      });
    });
  }

  eventCopy_CLICKHandler() {
    this.openModal();
  }

  private openModal() {
    const componentRef = this.dialogService.openModal(KYMW6902Component);
    const instance = componentRef.componentInstance as KYMW6902Component;
    instance.parent = this;
    instance.closeFunction = (isWindowClose = false) => {
      if (isWindowClose || !instance.output) {
        componentRef.close();
        return;
      }

      this.model.existingGoods = instance.output;
      this.getExistingGoodsCopyService.execute(this.model, this.getExistingGoodsCopyServiceSuccess);
      componentRef.close();
    };
  }

  // getExistingGoodsCopyService.executeの成功時処理
  getExistingGoodsCopyServiceSuccess = (ClassCode : string) => {
    // バイヤーコンボを再作成
    this.getClassBuyerIdService.execute(ClassCode, (buyerList: BuyerListModel) => {
      this.model.setBuyerList(buyerList);
    });

    // マスタ入力表のマークコンボを再作成
    this.model.parent.MasterInputTab.initMarkDiv();    

  }

  eventClassCode_CHANGEHandler() {
    this.model.newGoodsProposal.buyerUserId = '';

    const classCode = this.cmb_ClassCode.selectedClassCode;
    if (!classCode) {
      return;
    }

    this.getClassBuyerIdService.execute(classCode, (buyerList: BuyerListModel) => {
      this.model.setBuyerList(buyerList);
    });
  }

  eventPrefferedExpansionDiv_CHANGEHandler() {
    if (this.model.newGoodsProposal.preferredExpansionDiv !== this.PREFERRED_EXPANSION_DIV_OTHER) {
      this.model.newGoodsProposal.preferredExpansionOther = '';
    }
  }

  eventAllCoop_CHANGEHandler() {
    const coops = Object.keys(this.model.newGoodsProposal.expandableCoop);
    this.model.newGoodsProposal.expandableCoop = coops.reduce((prev, coop) =>
      ({ ...prev, [coop]: this.model.newGoodsProposal.allCoop }),
      this.model.newGoodsProposal.expandableCoop);
  }
  eventCoop_CHANGEHandler() {
    const isAllChecked = Object.values(this.model.newGoodsProposal.expandableCoop).every(coopChecked => coopChecked);
    this.model.newGoodsProposal.allCoop = isAllChecked;
  }


  eventStandardPrice_CHANGEHandler() {
    this.model.newGoodsProposal.standardGpr = KYMW6901ProposalTabModel.calcGpr(
      this.model.newGoodsProposal.standardSellingPrice,
      this.model.newGoodsProposal.standardCostPrice
    );
  }
  eventSpecial1Price_CHANGEHandler() {
    this.model.newGoodsProposal.special1Gpr = KYMW6901ProposalTabModel.calcGpr(
      this.model.newGoodsProposal.special1SellingPrice,
      this.model.newGoodsProposal.special1CostPrice
    );
  }
  eventSpecial2Price_CHANGEHandler() {
    this.model.newGoodsProposal.special2Gpr = KYMW6901ProposalTabModel.calcGpr(
      this.model.newGoodsProposal.special2SellingPrice,
      this.model.newGoodsProposal.special2CostPrice
    );
  }

  eventUploadImage_CLICKHandler() {
    this.fileUploadService.upload((files: File[]) => {
      const fullFileName = files[0].name;
      const fileExtension = PlessViewUtilsSub.getExtension(fullFileName);
      const fileName = fullFileName.replace(new RegExp(`(.*)\.${fileExtension}`), '$1');
      const found = fileName.match(this.forbiddenCharactersRegex);
      if (found) {
        this.dialogService.openAlertGetMessage('E0545', [found[0]]);
        return;
      }
      this.imagePhotoFileUploadService.execute(this.model, files[0]);
      this.model.newGoodsProposal.imageFileName = fullFileName;
    }, ['jpeg', 'jpg', 'png']);
  }

  eventOutputImage_CLICKHandler() {
    this.dialogService.openAlertGetMessage('Q0109', null, (closeDetail: PlessAlert) => {
      if (closeDetail === PlessAlert.Yes) {
        this.outputImage();
      }
    });
  }

  private outputImage() {
    this.imagePhotoDownloadService.execute(this.model, (filePath) => {
      if (!filePath) {
        this.dialogService.openAlertGetMessage('E0100');
        return;
      }
      this.fileDownloadConfirmService.show(filePath, this.model.newGoodsProposal.imageFileName);
    });
  }

  eventSave_CLICKHandler() {
    const error = this.model.validate();
    if (error) {
      this.dialogService.openAlertGetMessage(error.code, error.message);
      return;
    }
    if (this.model.parent.MasterInputTab.model.existsMasterInputValue()) {
      const masterError = this.model.parent.MasterInputTab.model.validate();
      if (masterError) {
        this.model.parent.model.showMasterInputTab();
        this.dialogService.openAlertGetMessage(masterError.code, masterError.message);
        return;
      }
    }
    if (this.model.newGoodsProposal.proposalId) {
      this.updateNewGoodsProposalService.execute(this.model, this.model.newGoodsProposal.proposalStatus, () => {
        this.proposalToMasterInput();
        this.registUpdateSuccess(this.model.newGoodsProposal.proposalId, this.model.newGoodsProposal.classCode);
      });
    } else {
      // バイヤーとグループ長の場合、提案者にはダミーコードを設定する
      const proposalUserId = this.model.isBuyer() || this.model.isGroupLeader() ? this.DUMMY_CLIENT_CODE : this.model.userId();
      this.registNewGoodsProposalService.execute(this.model, proposalUserId, KYMW6900Model.PROPOSAL_STATUS_PROPOSAL_BEFORE, (proposalId) => {
        this.proposalToMasterInput();
        this.registUpdateSuccess(proposalId, this.model.newGoodsProposal.classCode);
      });
    }
  }

  eventProposal_CLICKHandler() {
    const error = this.model.validate();
    if (error) {
      this.dialogService.openAlertGetMessage(error.code, error.message);
      return;
    }
    if (this.model.parent.MasterInputTab.model.existsMasterInputValue()) {
      const masterError = this.model.parent.MasterInputTab.model.validate();
      if (masterError) {
        this.model.parent.model.showMasterInputTab();
        this.dialogService.openAlertGetMessage(masterError.code, masterError.message);
        return;
      }
    }

    if (this.model.newGoodsProposal.proposalId) {
      this.updateNewGoodsProposalService.execute(this.model, KYMW6900Model.PROPOSAL_STATUS_PROPOSING, () => {
        this.proposalToMasterInput();
        this.registUpdateSuccess(this.model.newGoodsProposal.proposalId, this.model.newGoodsProposal.classCode);
      });
    } else {
      // バイヤーとグループ長の場合、提案者にはダミーコードを設定する
      const proposalUserId = this.model.isBuyer() || this.model.isGroupLeader() ? this.DUMMY_CLIENT_CODE : this.model.userId();
      this.registNewGoodsProposalService.execute(this.model, proposalUserId, KYMW6900Model.PROPOSAL_STATUS_PROPOSING, (proposalId) => {
        this.proposalToMasterInput();
        this.registUpdateSuccess(proposalId, this.model.newGoodsProposal.classCode);
      });
    }
  }

  eventBuyerApprove_CLICKHandler() {
    this.registNewGoodsProposalGoodsService.execute(this.model, this.passedProposalId, () => {
      this.updateSuggestionStatusRecruimentService.execute(this.model, KYMW6900Model.PROPOSAL_STATUS_BUYER_APPROVED, () => {
        this.dialogService.openAlertGetMessage('I0106', ['処理が完了'], () => {
          this.navigateKYMW6900();
        });
      });
    });
  }

  eventBuyerReject_CLICKHandler() {
    this.updateSuggestionStatusRejectedService.execute(this.model, KYMW6900Model.PORPOSAL_STATUS_BUYER_REJECTED, () => {
      this.dialogService.openAlertGetMessage('I0106', ['処理が完了'], () => {
        this.navigateKYMW6900();
      });
    });
  }

  private navigateKYMW6900() {
    this.router.navigate(['/kymw/6900'], {
      queryParams: {
        searchProposalStatus: this.searchParams.searchProposalStatus,
        searchClassCode: this.searchParams.searchClassCode,
        searchProposalUserId: this.searchParams.searchProposalUserId,
        searchBuyerId: this.searchParams.searchBuyerId,
        searchGoodsAndStandardName: this.searchParams.searchGoodsAndStandardName,
        searchStartOrderCode: this.searchParams.searchStartOrderCode,
        searchDelivCatalogId: this.searchParams.searchDelivCatalogId,
        searchPCode: this.searchParams.searchPCode,
        searchMasterInputStatus: this.searchParams.searchMasterInputStatus
      }
    });
  }

  hasChanged() {
    return this.model.hasChanged;
  }

  registUpdateSuccess = (proposalId, classCode) => {
    if (this.model.parent.MasterInputTab.model.masterInput.masterInputId) {
      this.model.parent.updateMasterInput(() => {
        this.dialogService.openAlertGetMessage('I0106', ['処理が完了'], () => {
          this.navigateKYMW6900();
        });
      });
    } else {
      if (this.model.parent.MasterInputTab.model.existsMasterInputValue()) {
        this.model.parent.registerMasterInput(proposalId, classCode, () => {
          this.dialogService.openAlertGetMessage('I0106', ['処理が完了'], () => {
            this.navigateKYMW6900();
          });
        });
      } else {
          // マスタ入力表がない場合は終了メッセージのみ表示
          this.dialogService.openAlertGetMessage('I0106', ['処理が完了'], () => {
            this.navigateKYMW6900();
          });
      }
    }
  }
  
  proposalToMasterInput = () => {
    // 特定項目をマスタ項目表側にコピー
    this.model.parent.MasterInputTab.model.masterInput.standardSellingPrice = this.model.newGoodsProposal.standardSellingPrice;
    this.model.parent.MasterInputTab.model.masterInput.special1SellingPrice = this.model.newGoodsProposal.special1SellingPrice;
    this.model.parent.MasterInputTab.model.masterInput.special2SellingPrice = this.model.newGoodsProposal.special2SellingPrice;
    this.model.parent.MasterInputTab.model.masterInput.standardCostPrice = this.model.newGoodsProposal.standardCostPrice;
    this.model.parent.MasterInputTab.model.masterInput.special1CostPrice = this.model.newGoodsProposal.special1CostPrice;
    this.model.parent.MasterInputTab.model.masterInput.special2CostPrice = this.model.newGoodsProposal.special2CostPrice;
    this.model.parent.MasterInputTab.model.masterInput.expirationDate = this.model.newGoodsProposal.expirationDate;
  	this.model.parent.MasterInputTab.model.masterInput.bestBeforeDate = this.model.newGoodsProposal.bestBeforeDate;
    this.model.parent.MasterInputTab.model.masterInput.expandableCoop = this.model.newGoodsProposal.expandableCoop;
  }
  
  eventGoodsName_FOCUS_OUTHandler(): void {
    this.model.parent.MasterInputTab.model.masterInput.goodsName = this.model.newGoodsProposal.goodsName;
  }

  eventStandardName_FOCUS_OUTHandler(): void {
    this.model.parent.MasterInputTab.model.masterInput.standardName = this.model.newGoodsProposal.standardName;
  }

  eventJanCode_FOCUS_OUTHandler(): void {
    this.model.parent.MasterInputTab.model.masterInput.janCode = this.model.newGoodsProposal.janCode;
  }
}
